export default __webpack_public_path__ + "5a16f3112c1c100c58c7b623c1857dc7.svg";